<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app {
  width: 100vw;
  height: 100vh;
  overflow: hidden;
}

/* ══ 全局弹出层暗色覆盖（el-select/el-cascader/el-dropdown 挂到 body 的 portal） ══ */
.el-select-dropdown,
.el-cascader__dropdown {
  background: #08102a !important;
  border: 1px solid rgba(0, 255, 255, 0.2) !important;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.5) !important;
}
.el-select-dropdown__item {
  color: rgba(180, 210, 255, 0.8) !important;
}
.el-select-dropdown__item:hover,
.el-select-dropdown__item.hover {
  background: rgba(0, 255, 255, 0.08) !important;
  color: #00ffff !important;
}
.el-select-dropdown__item.selected {
  color: #00ffff !important;
  font-weight: 600;
}
.el-cascader-menu {
  background: #08102a !important;
  border-right: 1px solid rgba(0, 255, 255, 0.1) !important;
  color: rgba(180, 210, 255, 0.8) !important;
}
.el-cascader-node:hover,
.el-cascader-node:focus {
  background: rgba(0, 255, 255, 0.07) !important;
  color: #00ffff !important;
}
.el-cascader-node.in-active-path,
.el-cascader-node.is-active {
  color: #00ffff !important;
}
.el-picker-panel {
  background: #08102a !important;
  border: 1px solid rgba(0, 255, 255, 0.2) !important;
  color: rgba(180, 210, 255, 0.85) !important;
}
.el-picker-panel__header-label,
.el-date-picker__header-label {
  color: #00ffff !important;
}
.el-date-table th {
  color: rgba(0, 255, 255, 0.5) !important;
}
.el-date-table td.available .el-date-table-cell__text {
  color: rgba(180, 210, 255, 0.8) !important;
}
.el-date-table td.today .el-date-table-cell__text {
  color: #00ffff !important;
  font-weight: bold;
}
.el-date-table td.current:not(.disabled) .el-date-table-cell__text,
.el-date-table td.in-range .el-date-table-cell {
  background: rgba(0, 255, 255, 0.12) !important;
}
.el-date-range-picker__time-header,
.el-date-range-picker__content {
  border-color: rgba(0, 255, 255, 0.15) !important;
}
.el-picker-panel__icon-btn {
  color: rgba(0, 255, 255, 0.6) !important;
}
.el-picker-panel__icon-btn:hover {
  color: #00ffff !important;
}
.el-time-panel {
  background: #08102a !important;
  border: 1px solid rgba(0, 255, 255, 0.2) !important;
}
.el-time-spinner__item {
  color: rgba(180, 210, 255, 0.7) !important;
}
.el-time-spinner__item.active:not(.disabled) {
  color: #00ffff !important;
}
.el-dropdown-menu {
  background: #08102a !important;
  border: 1px solid rgba(0, 255, 255, 0.2) !important;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.5) !important;
}
.el-dropdown-menu__item {
  color: rgba(180, 210, 255, 0.8) !important;
}
.el-dropdown-menu__item:hover {
  background: rgba(0, 255, 255, 0.08) !important;
  color: #00ffff !important;
}
.el-dropdown-menu__item--divided {
  border-top: 1px solid rgba(0, 255, 255, 0.1) !important;
}
.el-dropdown-menu__item--divided::before {
  background: transparent !important;
}
.el-message-box {
  background: #08102a !important;
  border: 1px solid rgba(0, 255, 255, 0.2) !important;
}
.el-message-box__title { color: #00ffff !important; }
.el-message-box__content { color: rgba(180, 210, 255, 0.85) !important; }
.el-message-box__headerbtn .el-message-box__close { color: rgba(0, 255, 255, 0.5) !important; }
.el-loading-mask { background: rgba(6, 9, 26, 0.8) !important; }
.el-loading-spinner .el-loading-text { color: rgba(0, 255, 255, 0.7) !important; }
.el-loading-spinner .path { stroke: rgba(0, 255, 255, 0.7) !important; }
</style>
